import schema from './schema'
import linkAlternate from './linkAlternate'

export default {
  schema,
  linkAlternate,
}
